/**
 * @owner @Appboy/in-app-messages
 */

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const submittedSurveyLandingPageFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("submitted_survey_landing_page_filter"),
  comparison_key: z.enum(["7", "8"]),
  display_name: z.string(),
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(false),
});
